import { isScopeAssignableAtLevel } from './scopes';
export const rolePresets = [
    {
        title: 'Roadmap viewer',
        description: "View the organization's enterprise roadmap without organization administration permissions.",
        level: 'organization',
        scopes: ['view:Roadmap'],
    },
    {
        title: 'SQL Runner user',
        description: 'Run warehouse SQL through SQL Runner, AI agents, and MCP without project deployment or SQL-authoring permissions.',
        level: 'project',
        scopes: ['manage:SqlRunner'],
    },
    {
        title: 'SQL author',
        description: 'Run warehouse SQL and author SQL charts, custom SQL dimensions, and SQL table calculations.',
        level: 'project',
        scopes: [
            'manage:SqlRunner',
            'manage:CustomSql',
            'manage:CustomFields',
            'manage:CustomSqlTableCalculations',
            'view:CompiledSql',
        ],
    },
    {
        title: 'Data App builder',
        description: 'Create Data Apps and manage the apps you build, including in production projects.',
        level: 'project',
        scopes: ['create:DataApp'],
    },
    {
        title: 'AI agent manager',
        description: 'Create and manage all AI agents, their knowledge documents and their skills in assigned projects.',
        level: 'project',
        scopes: [
            'manage:AiAgent',
            'manage:AiAgentDocument',
            'manage:AiAgentSkill',
        ],
    },
];
export const isRolePresetAvailableAtLevel = (preset, level) => preset.level === level &&
    preset.scopes.every((scope) => isScopeAssignableAtLevel(scope, level));
//# sourceMappingURL=rolePresets.js.map